import React, { useEffect, useState } from 'react';
import { PageHeader } from 'fwtheme-react-jasmin';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { LoadingSpinner } from '../components/Notifications/Loading';
import { GwsErrorNotify } from '../components/Notifications/GwsError';
import './MyGWS.css';

export function MyGWSPage() {
  useEffect(() => {
    document.title = 'My GWSs | JASMIN Group Workspace Scanner';
  }, []);
  const [isLoading, setLoading] = useState(true);
  const [catchError, setError] = useState(false);
  const [userServices, setUserServices] = useState({
    name: '', location: '',
  });
  useEffect(() => {
    try {
      const fetchUserServices = async () => {
        const result = await axios(
          '/api/user-services',
          { headers: { Accept: 'application/json' } },
        );
        setUserServices(result.data);
        setLoading(false);
      };
      fetchUserServices();
    } catch (err) {
      if (err.response) {
        setError([err.response.status, err.response.statusText]);
      } else if (err.message) {
        setError(['-', err.message]);
      } else {
        setError([' ', 'No details given.']);
      }
    }
  }, []);
  if (catchError) {
    return GwsErrorNotify('Error loading your group workspaces.', catchError[0], catchError[1]);
  }
  return (
    <div>
      <PageHeader>My Group Workspaces</PageHeader>
      <p>
        The group workspaces you have access to are listed below.
        Click on the location to go to the tree page.
      </p>
      { isLoading ? (
        LoadingSpinner()
      ) : (
        <div className="col-lg-5 col-md-6">
          <div className="card">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th aria-label="blank-table-header"> </th>
                  <th>Service Name</th>
                  <th>Location</th>
                  <th aria-label="blank-table-header"> </th>
                </tr>
              </thead>
              <tbody>
                {userServices.map((d) => (
                  <tr key={d.name}>
                    <td aria-label="blank-table-data"> </td>
                    <td><code>{d.name}</code></td>
                    <td><Link to={`/tree${d.location}`}>{d.location}</Link></td>
                    <td aria-label="blank-table-data"> </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
